<template>
  <div :id="id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="BlogSearchComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()"
       :keyChange="keyChange"
       v-on:click="focusElement($event)">

       <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="150"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

        <options-element-bar ref="optionsBar" :elem="this" name='ct-component-BlogSearchComponent'>
          <!-- <img src="static/images/icons/engrenagem.svg"
               class="svg-icon normal-action"
               @click="openModal"/> -->
        </options-element-bar>

         <div class="input-group mb-3">
           <input type="text" class="form-control"  :placeholder="placeholder()">
           <div class="input-group-append">
             <button class="btn btn-outline-secondary button-search" :style="buttonStyle()" type="button"> <i :style="iconStyle()" class="fas fa-search"></i> </button>
           </div>
         </div>

      </vue-draggable-resizable>
  </div>

</template>

<script>

import elementData from './Model';
import OptionsElementBar from '../../OptionsElementBar';
import _ from "lodash";

export default {
  name: 'BlogSearchComponent',
  props: ['config', 'id'],
  components: {OptionsElementBar},
  data() {
    return elementData.data();
  },
  methods: {
    placeholder() {
      return this.internal_config.showPlaceholder ? this.internal_config.lbltext : '';
    },
    handler: function(e) {
      // this.$el.classList.add('animated', 'jello', 'infinite');
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },
    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';
    },
    build(config) {
      this.internal_config = _.merge(this.internal_config, config);
      this.keyChange++;

      let vm = this;
      vm.$forceUpdate();

      this.$eventHub.setValueElementConfig(vm.id, vm.internal_config);

      document.documentElement.style.setProperty('--color-hover', this.internal_config.backgroundColorHover);
    },
    animation() {
      return false;
    },
    iconStyle() {
      return `color: ${this.internal_config.titleStyle.color}`;
    },
    openModal() {
      this.$root.$emit('openModal', 123, 123, 123);
    },
    titleStyleMobile() {
      return `font-family:  ${this.internal_config.titleStyle.family};
                  font-size: ${this.internal_config.titleStyle.sizeMobile};
                  text-align: ${this.internal_config.titleStyle.align};
                  font-weight: ${this.internal_config.titleStyle.weight};
                  font-style: ${this.internal_config.titleStyle.style};
                  text-decoration: ${this.internal_config.titleStyle.stroke};
                  color: ${this.internal_config.titleStyle.color}`;
    },
    buttonStyle() {
      return `font-family:  ${this.internal_config.contentStyle.family};
                  background-color: ${this.internal_config.backgroundColor};
                  font-size: ${this.internal_config.contentStyle.size};
                  text-align: ${this.internal_config.contentStyle.align};
                  font-weight: ${this.internal_config.contentStyle.weight};
                  font-style: ${this.internal_config.contentStyle.style};
                  text-decoration: ${this.internal_config.contentStyle.stroke};
                  color: ${this.internal_config.contentStyle.color};
                  min-height: auto;
                  border-top-left-radius: 0;
                  border-bottom-left-radius: 0;
                  border: 0`;
    },

    // style methods

    style() {
      let {
        left,
        zIndex,
        paddingTop,
        paddingLeft,
        paddingRight,
        paddingBottom,
        top
      } = this.internal_config;

      let style = `  left:  ${left};
                     z-index: ${zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${paddingTop};
                     padding-left: ${paddingLeft};
                     padding-right: ${paddingRight};
                     padding-bottom: ${paddingBottom};
					          top: ${top}`;

      return style;
    }
  },
  created() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== 'undefined') {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    let vm = this;

    this.build(this.$props.config);
    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id === id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    let objIds = [];
    $('[id]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) { objIds.push(this.id) }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }
  }
};
</script>

<style>

  [element="BlogSearchComponent"] .vdr {
    height: auto !important;
    min-width: 250px;
  }

  .button-search:hover{
    background-color: var(--color-hover) !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Search/Search.vue